<template>
    <v-row v-if="'hijriYear' in tender">
        <v-col>
            <v-card>
                <v-card-title>
                    Eid-Ul-Adha {{ tender.hijriYear }}H
                </v-card-title>
                <v-card-text>
                    <v-btn href="/tender/list" size="small">Master List</v-btn>
                    <v-btn :href="`/tender/${tender.tenderId}/customers`" class="ml-2" size="small">Customers</v-btn>
                    <v-btn :href="`/tender/${tender.tenderId}/detail`" class="ml-2" size="small">Tender</v-btn>
                    <v-btn :href="`/tender/${tender.tenderId}/expenses`" class="ml-2" size="small">Expenses</v-btn>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
    <v-row v-if="'goatTotal' in hidesSummary">
        <v-col>
            <v-card color="deep-purple">
                <v-card-text>
                    <h1>{{ hidesSummary.sheepTotal }}</h1>
                    <h3 class="mt-2">Sheep</h3>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col>
            <v-card color="indigo">
                <v-card-text>
                    <h1>{{ hidesSummary.goatTotal }}</h1>
                    <h3 class="mt-2">Goat</h3>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col>
            <v-card color="blue">
                <v-card-text>
                    <h1>{{ hidesSummary.cowTotal }}</h1>
                    <h3 class="mt-2">Cow</h3>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col>
            <v-card color="cyan">
                <v-card-text>
                    <h1>{{ hidesSummary.camelTotal }}</h1>
                    <h3 class="mt-2">Camel</h3>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
    <v-row v-if="divisionSummary.length" class="mt-2">
        <v-col>
            <v-card>
                <v-card-title>
                    Division Wise Hide Count
                </v-card-title>
                <v-card-text>
                    <v-table density="compact">
                        <thead>
                            <tr>
                                <th>Division</th>
                                <th>Sheep</th>
                                <th>Goat</th>
                                <th>Cow</th>
                                <th>Camel</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="division in divisionSummary" :key="division.organizationId">
                                <td>{{ division.organizationName }}</td>
                                <td>{{ division.totalSheep }}</td>
                                <td>{{ division.totalGoat }}</td>
                                <td>{{ division.totalCow }}</td>
                                <td>{{ division.totalCamel }}</td>
                            </tr>
                            <tr>
                                <td><strong>Total</strong></td>
                                <td><strong>{{ divisionTotals.totalSheep }}</strong></td>
                                <td><strong>{{ divisionTotals.totalGoat }}</strong></td>
                                <td><strong>{{ divisionTotals.totalCow }}</strong></td>
                                <td><strong>{{ divisionTotals.totalCamel }}</strong></td>
                            </tr>
                        </tbody>
                    </v-table>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>
<script setup>
import { ref, inject, onMounted, computed } from "vue";
import * as tenderService from "@/services/tenderService";

const loader = inject("loader");
const snackbar = inject("snackBar");

const tender = ref({});
const hidesSummary = ref({});
const divisionSummary = ref([]);

const divisionTotals = computed(() => ({
    totalSheep: totalBy("totalSheep"),
    totalGoat: totalBy("totalGoat"),
    totalCow: totalBy("totalCow"),
    totalCamel: totalBy("totalCamel"),
}));

function totalBy(key) {
    return divisionSummary.value.reduce((sum, division) => sum + Number(division[key] ?? 0), 0);
}

async function getData() {
    loader.show();

    try {
        const result = await tenderService.tender_getActive();

        if (result) {
            tender.value = result;
            await getSummary();
        }
    } catch (ex) {
        snackbar.error(ex);
    } finally {
        loader.hide();
    }
}

async function getSummary() {
    const [summary, summaryByDivision] = await Promise.all([
        tenderService.hides_summary(tender.value.tenderId),
        tenderService.hides_summary_by_division(tender.value.tenderId),
    ]);

    hidesSummary.value = summary;
    divisionSummary.value = summaryByDivision;
}

onMounted(async () => {
    await getData();
});

</script>